module.exports = __webpack_public_path__ + "static/image/service/pc/takeout@3x.ver2_0_2.jpg?e3cac148";